import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-notifications-component/dist/theme.css';
import './index.css';
import './css/I3Portal.scss';
import './i18n/i18n';

import { Suspense, StrictMode } from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { keycloak } from './keycloak';
import App from './App';
import ReactDOM from 'react-dom';
import { ReactNotifications } from 'react-notifications-component';
import { UserContextProvider } from './context/UserContext';
import reportWebVitals from './reportWebVitals';

const savedToken = localStorage.getItem('kc_token');
const savedRefreshToken = localStorage.getItem('kc_refreshToken');

const keycloakInitOptions = {
  checkLoginIframe: false,
  pkceMethod: 'S256',
};

// Se ci sono token salvati, passali a Keycloak
if (savedToken && savedRefreshToken) {
  keycloakInitOptions.token = savedToken;
  keycloakInitOptions.refreshToken = savedRefreshToken;
}

const handleTokens = (tokens) => {
  if (tokens?.token) {
    localStorage.setItem('kc_token', tokens.token);
    localStorage.setItem('kc_refreshToken', tokens.refreshToken);
    if (tokens.idToken) {
      localStorage.setItem('kc_idToken', tokens.idToken);
    }
  }
};

const handleEvent = (event) => {
  if (event === 'onAuthLogout' || event === 'onAuthError') {
    localStorage.removeItem('kc_token');
    localStorage.removeItem('kc_refreshToken');
    localStorage.removeItem('kc_idToken');
  }
};

ReactDOM.render(
  <StrictMode>
    <Suspense fallback="">
      <ReactKeycloakProvider 
        authClient={keycloak} 
        initOptions={keycloakInitOptions}
        onTokens={handleTokens}
        onEvent={handleEvent}
      >
        <ReactNotifications />
        <UserContextProvider>        
            <App />
        </UserContextProvider>
      </ReactKeycloakProvider>
    </Suspense>
  </StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
